
<template>
  <div>
    <v-subheader>Necessária a validação por QrCode?</v-subheader>
    <v-switch class="ml-5 mt-0" hide-details label="Sim" inset dense v-model="newItem.needs_verification_by_qr_code" value='custom_field' color="secondary"></v-switch>
    <span class="caption orange--text ml-5 mt-n10" v-if="newItem.needs_verification_by_qr_code">
      Somente será possível continuar a execução caso o QrCode escaneado seja referente ao elemento selecionado da lista abaixo 
    </span>
    <div v-if="!!newItem.needs_verification_by_qr_code">
      <v-col align="center" justify="start" class="ml-6" v-if="newItem.needs_verification_by_qr_code == 'custom_field'">
        <v-select
          v-if="!loading_root"
          :items="elements_root"
          v-model="newItem.qr_code_ref"
          label="Conecte a uma lista"
          item-text="name"
          item-value="id"
          prepend-icon="mdi-database-import mdi-flip-h"
          color="secondary"
          item-color="secondary"
          :rules="required"
        >
          <template v-slot:append-item>
            <v-divider class="mt-2"></v-divider>
            <v-row justify="center" class="pt-3">
              <v-btn color="secondary" :to="{name: 'ListCustomField'}" rounded><v-icon left>mdi-plus</v-icon>Nova Lista</v-btn>
            </v-row>
          </template>
        </v-select>

        <v-autocomplete
          v-if="newItem.qr_code_ref && !loading_exact"
          :items="elements_exact"
          v-model="newItem.qr_code_value"
          label="Vincule a um elemento com QrCode"
          item-text="main"
          item-value="qrcode_value"
          prepend-icon="mdi-qrcode"
          color="secondary"
          :rules="required"
        >
          <!-- <template v-slot:append-item>
            <v-divider class="mt-2"></v-divider>
            <v-row justify="center" class="pt-3">
              <v-btn color="primary" :to="{name: 'ListCustomField'}" rounded><v-icon left>mdi-plus</v-icon>Nova Lista</v-btn>
            </v-row>
          </template> -->
        </v-autocomplete>
        <card-loading-transparent v-if="loading_root || loading_exact"></card-loading-transparent>

      </v-col>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import Api from '@/api/index';

export default {
  name: 'QrcodeVerificationConfig',
  mixins: [ validations ],
  components: {
    //ComponentName: () => import(''),
  },
  data() {
    return {
      newItem: this.$attrs.newItem,

      elements_root: [],
      loading_root: false,

      elements_exact: [],
      loading_exact: false,

      original_needs_verification: null,
      original_qr_code_ref: null,
      original_qr_code_value: null,
    }
  },
  methods: {
    getElementsRootByQrcodeModel() {
      const mapper = {
        'custom_field': () => this.getCustomFields(),
        'null': () => {},
      }
      mapper[this.newItem.needs_verification_by_qr_code]()
    },
    getElementsExactByQrcodeModel() {
      const mapper = {
        'custom_field': (custom_field_id) => this.getCustomValues(custom_field_id),
        'null': () => {},
      }
      mapper[this.newItem.needs_verification_by_qr_code](this.newItem.qr_code_ref)
    },
    getCustomFields(){
      this.loading_root = true
      Api.CustomField.index().then(r=>r.data).then(cf=>{
        cf = cf.data? cf.data.map(c=> c.attributes) : cf
        this.elements_root = [...cf.map(c=> {
          const disabled = c.status != 'active'
          const id = c.id.toString()
          return {...c, disabled, id}
        })]
      }).finally(()=>{
        this.loading_root = false
      })
    },
    getCustomValues(id){
      this.loading_exact = true
      Api.CustomValue.indexByModel( null, id).then(r=>r.data).then(cvs=>{
        this.elements_exact = [...cvs]
      }).finally(()=>{
        this.loading_exact = false
      })
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  mounted () {
    this.original_needs_verification = this.newItem.needs_verification
    this.original_qr_code_ref = this.newItem.qr_code_ref
    this.original_qr_code_value = this.newItem.qr_code_value
    this.getElementsRootByQrcodeModel()
    this.getElementsExactByQrcodeModel()
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    'newItem.needs_verification_by_qr_code'(nv,ov) {
      console.log({nv});
      if (nv){
        this.getElementsRootByQrcodeModel()
      } else {
        this.newItem.qr_code_ref = null
      }
    },
    'newItem.qr_code_ref'(nv,ov) {
      console.log({nv});
      if (nv){
        this.getElementsExactByQrcodeModel()
      } else{
        this.newItem.qr_code_value = null
      }
    }
  },
}
</script>

<style scoped>

</style>